// extracted by mini-css-extract-plugin
export default {"flag":"style_flag__4Dmj3","flagImg":"style_flagImg__Aow7h"};